import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const TOKEN_KEY = "yarn_token";

export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const errorText = (e) => formatApiErrorDetail(e?.response?.data?.detail) || e.message;

export const socketUrl = (code) =>
  `${BACKEND_URL.replace(/^http/, "ws")}/api/ws/${code}?token=${encodeURIComponent(localStorage.getItem(TOKEN_KEY) || "")}`;

export const THEMES = [
  { key: "comedy", label: "Comedy" },
  { key: "feel_good", label: "Feel Good" },
  { key: "horror", label: "Horror" },
  { key: "drama", label: "Drama" },
  { key: "mystery", label: "Mystery" },
  { key: "adventure", label: "Adventure" },
  { key: "sci_fi", label: "Sci-Fi" },
  { key: "fantasy", label: "Fantasy" },
  { key: "romance", label: "Romance" },
  { key: "surprise", label: "Surprise me" },
];

export const themeLabel = (key) => THEMES.find((t) => t.key === key)?.label || "Comedy";

const YARN_COLORS = ["#C85A32", "#D97706", "#4D7C5F", "#7C3AED", "#2563EB", "#DB2777", "#0D9488", "#B45309", "#DC2626", "#65A30D"];

export function yarnColor(id) {
  if (!id) return "#2C221E";
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return YARN_COLORS[h % YARN_COLORS.length];
}
